import React from 'react';
import { Link } from 'react-router-dom';
import './OperationLink.less';
import { jsx as _jsx } from "react/jsx-runtime";
export const OperationLink = ({
  disabled = false,
  ...props
}) => {
  if (disabled) {
    return /*#__PURE__*/_jsx("span", {
      className: "icloud-ui-pro-table-operation-link-disabled",
      ...props
    });
  }

  return /*#__PURE__*/_jsx(Link, { ...props
  });
};
//# sourceMappingURL=es/OperationLink.js.map